export const notGreaterThan = (getComparisonValue) => (value) => {
    const threshold = getComparisonValue()

    const isNumeric = (num) => !isNaN(num) && isFinite(num)
    if (!isNumeric(threshold) || !isNumeric(value)) {
        return false
    }

    return !value || !threshold || parseFloat(value) <= parseFloat(threshold)
}

const isEmpty = (value) => value === null || value === undefined || value === ''

// True when the value matches the `value` of one of the options returned by getOptions, read at call time.
export const isOneOfOptions = (getOptions) => (value) => {
    if (isEmpty(value)) return false
    return (getOptions() || []).some((option) => String(option.value) === String(value))
}

// Empty passes (pair with `required` where needed), otherwise the value must be one of the options.
export const oneOfOptionsOrEmpty = (getOptions) => (value) => isEmpty(value) || isOneOfOptions(getOptions)(value)
